module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing_4_ES-b390b5fdc6d4fa67cb304e3cd13cd440.svg";